// Copyright (c) 2016 Deere & Company

import MeasurementReading from '@deere/cps-it.warranty-model-factory/lib/measurement-reading';
import t from 'tcomb';

const AmountOfUseHistory = t.list(MeasurementReading, 'AmountOfUseHistory');

export const getDefaultState = () => new AmountOfUseHistory([]);

export default AmountOfUseHistory;



// WEBPACK FOOTER //
// ./src/product/details/state/amount-of-use-history.js